import { defineStore } from 'pinia'
import { useSyncableModel } from '@/composables/useSyncableModel.js'
import { useApiResource } from '@/composables/resources/useApiResource.js'
import Farm from '@/models/Farm.js'

export const useFarmStore = defineStore('farmStore', () => {
  let syncableModel = useSyncableModel(useApiResource('farms'), {
    className: Farm.modelName.name,
    paramKey: Farm.modelName.paramKey
  })

  function $reset() {
    syncableModel.collection.value = []
  }

  return {
    ...syncableModel,
    $reset
  }

}, {
  persist: true
})

